import React, { Component, Fragment } from "react";
import { graphql, compose } from "react-apollo";
import Carousel, { Dots } from "@brainhubeu/react-carousel";
import "@brainhubeu/react-carousel/lib/style.css";
import Modal from "react-responsive-modal";
import { Button, Card, CardImg, CardText, CardBody, CardTitle, CardSubtitle, Row, Col } from "reactstrap";
import moment from "moment";
import NO_IMAGE from "../../assets/img/aa-no-image.png";
import parseHtml, { domToReact } from "html-react-parser";

import "../AdvancedSearch/SearchItem/SearchItem.css";
import IsInterestedModal from "../IsInterestedModal/IsInterestedModal.js";
import CruiseLine from "../../queries/CruiseLine";
import Destinations from "../../queries/HomeDestinations";
import Flotas from "../../queries/HomeFlotas";
import "./DarkCarousel.css";

class DarkCarousel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currencyConverter: new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }),
      isInterested: false,
      open: false,
      value: 0,
    };
  }

  renderPrice(info) {
    let cruiseLineName = info?.cruiseLine.name;
    let priceTitle;
    const price = this.state.currencyConverter.format(info?.twoPerson);
    switch (cruiseLineName) {
      case "Circuito":
        priceTitle = `Precio de paquete por persona desde`;
        break;
      case "Hoteles":
        priceTitle = `Precio por persona por noche desde`;
        break;
      case "Ready 2 Go":
        priceTitle = `Precio de paquete por persona desde`;
        break;
      default:
        break;
    }
    if (info?.__typename === "Flota") priceTitle = "Por itinerario por persona";
    let cruiseLine = { ready2go: "ck69og9j5001e0774ba5nchpy" };
    if (price !== -1) {
      return (
        <Fragment>
          <CardText
            style={{
              alignSelf: "flex-end",
              marginBottom: "0px",
              textAlign: "right",
            }}
          >
            {priceTitle}
          </CardText>
          <div className="modalPriceText">{price} USD</div>
          <CardText
            style={{
              alignSelf: "flex-end",
              marginBottom: "0px",
              textAlign: "right",
            }}
          >
            Acomodo doble estándar
          </CardText>
          {this.props.data?.type === "flotas" && this.props.data?.cruiseLineId !== cruiseLine.ready2go ? (
            <CardSubtitle style={{ textAlign: "right", color: "gray", fontSize: "80%" }}> (excluye impuestos y propinas) </CardSubtitle>
          ) : null}
        </Fragment>
      );
    } else {
      return <CardText style={{ alignSelf: "flex-end", textAlign: "right" }}>Esta selección no está disponible con los filtros actuales.</CardText>;
    }
  }

  onChange = (value) => {
    this.setState({ value });
  };

  closeModal() {
    this.setState({ open: !this.state.open, info: null });
  }

  filterDevData = (data) => data.filter((dp) => dp.cruiseLine.nickname !== "dev");

  filterEndDateData = (data) => data.filter((dp) => moment(dp.endDate).isSameOrAfter(moment(new Date())));

  filterActiveData = (data) => data.filter((dp) => dp.active);

  render() {
    const { open, info } = this.state;
    let size = "3";
    if (this.props.count === size) {
      size = "4";
    }

    const { ready, destinations, flotas } = this.props;
    if (ready.loading || destinations.loading || flotas.loading) {
      return <div className="h-100" />;
    }

    let ds = [...destinations.recommendedDestinations, ...flotas.recommendedFlotas];

    ds = ds.map((dp) => {
      if (!dp.thumbnail) dp.thumbnail = NO_IMAGE;
      return dp;
    });

    ds = this.filterActiveData(ds);
    ds = this.filterEndDateData(ds);
    ds = this.filterDevData(ds);

    const slides =
      ds &&
      ds.map((slide, i) => {
        if (i < 4) {
          const { picture, thumbnail, link, imageURL } = slide;
          let image = picture ? picture : thumbnail;
          if (this.props.ready) {
            image = picture ? picture : thumbnail ? thumbnail : image ? image : NO_IMAGE;
          }

          return (
            <div
              key={`ready${i}`}
              className="carousel-slide"
              onClick={() => {
                // if prop ready is passed then you can provide a link to open in a modal
                if (this.props.ready) {
                  this.setState({ open: true, source: imageURL, info: slide });
                }
              }}
            >
              {/* this a tag works if you pass the resort prop then you can open a new tab with slide.link */}
              <div className="carousel-img-container">
                <a className="pointer" href={this.props.resort || this.props.cruise ? link : null} target={this.props.resort ? "_blank" : null}>
                  <img src={image} alt="slidePicture" className="slide-image" />
                </a>
              </div>
              {/* <div className="img-title-container">
                <h2 className="slideTitleDark">{title}</h2>
                {!this.props.cruise ? (
                  <p className="slideSubDark">{subtitle}</p>
                ) : null}
              </div> */}
            </div>
          );
        } else {
          return null;
        }
      });

    return (
      <Fragment>
        {slides ? (
          <Fragment>
            <Carousel
              slidesPerPage={3}
              infinite
              centered
              animationSpeed={3000}
              // autoPlay={5000}
              onChange={this.onChange}
              stopAutoPlayOnHover
              value={this.state.value}
              breakpoints={{
                1735: {
                  slidesPerPage: this.props.ready ? 3 : 2,
                  arrows: false,
                },
                1392: {
                  slidesPerPage: this.props.ready ? 2 : 1,
                  arrows: false,
                },

                600: {
                  slidesPerPage: 1,
                  arrows: false,
                },
              }}
            >
              {slides}
            </Carousel>
            <Dots value={this.state.value} onChange={(e) => this.onChange(e)} number={ds.length} />
            <Modal open={open} onClose={() => this.closeModal()}>
              {this.state.alert ? this.state.alert : null}
              <Card className="modalCard" style={{ maxHeight: "50%" }}>
                <CardImg className="modalImg" top src={info?.imageURL ? info.imageURL : NO_IMAGE} />
                <CardBody className="modalBody">
                  <Row>
                    <Col lg="8" md="8" sm="8">
                      <CardTitle className="modalTitle">{info?.name}</CardTitle>
                      <CardSubtitle className="modalSubtitle">{info?.subtitle}</CardSubtitle>
                    </Col>
                    <Col lg="4" md="4" sm="4">
                      <Button
                        color="primary"
                        className="btn-interest btn-pill float-right"
                        onClick={() => {
                          this.setState({ isInterested: true });
                        }}
                      >
                        <span>¡Me interesa!</span>
                      </Button>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <CardText className="modalOferta">
                        Oferta Válida: <br />
                        {`${moment(info?.startDate).locale("es_US").format("MMMM D, YYYY")}`} - {`${moment(info?.endDate).locale("es_US").format("MMMM D, YYYY")}`}
                      </CardText>
                    </Col>
                    <Col>
                      <div className="modalPrice">{this.renderPrice(info)}</div>
                    </Col>
                  </Row>

                  <Row>
                    <Col lg="6">
                      <CardText className="modalBodyHeader">DESCRIPCIÓN</CardText>
                    </Col>
                    {info?.descriptivo && (
                      <Col lg="6">
                        <Button color="primary" className="btn-pill float-right" href={info?.descriptivo} target="_blank">
                          <span>Descriptivo</span>
                        </Button>
                      </Col>
                    )}
                  </Row>

                  <div>
                    {parseHtml(info?.description ? info?.description : "No Description ", {
                      replace: (domNode) => {
                        if (domNode.name === "h1") {
                          return <CardTitle className="header1">{domToReact(domNode.children, domNode.options)}</CardTitle>;
                        }
                        if (domNode.name === "h2") {
                          return <CardTitle className="header2">{domToReact(domNode.children, domNode.options)}</CardTitle>;
                        }
                      },
                    })}
                  </div>
                </CardBody>
              </Card>
            </Modal>
            <IsInterestedModal isInterested={this.state.isInterested} setIsInterested={(value) => this.setState({ isInterested: value })} data={this.state.info} filters={this.props.filters} />
          </Fragment>
        ) : (
          <h1>Vuelva más tarde para encontrar nuevas recomendaciones.</h1>
        )}
      </Fragment>
    );
  }
}

export default compose(
  graphql(CruiseLine, {
    options: (props) => ({ variables: { nickname: "ready2go" } }),
    name: "ready",
  }),
  graphql(Destinations, { name: "destinations" }),
  graphql(Flotas, { name: "flotas" })
)(DarkCarousel);
